module.exports = __webpack_public_path__ + "assets/img/hotAir_off.f9eed86f.png";